<template>
  <div class="mb-4">
    <validation-provider ref="numProvider" :rules="providerRules" :disabled="isOptional" v-slot="{ errors }" :immediate="validateImmediate">
      <h6 v-if="displayError(errors, number + question.questionText)" class="text-danger">{{ errors[0] }}</h6>
      <div class="mb-1" :style="{ 'background-color': questionBackColor }"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></div>
      <div v-html="question.instructions" class="font-italic mb-1"></div>
      <div v-if="debugQuestions" class="text-warning">{{ question.hspCategoryQuestionId }} (state text: {{ stateResponseTextValue }})</div>
      <div class="row">
        <div class="col-sm-6 col-lg-3">
          <base-input>
            <el-input-number
              :label="inputLabel(number.length > 0 ? 'question ' + number : '')"
              class="input-number-border"
              v-model="stateResponseTextValue"
              :style="{ 'background-color': responsesBackColor }"
              :controls="controls"
              :step="1"
              :step-strictly="true"></el-input-number>
          </base-input>
        </div>
      </div>
    </validation-provider>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { InputNumber, Input } from 'element-ui';
import { mapGetters } from 'vuex';

export default {
  components: {
    ValidationProvider,
    [InputNumber.name]: InputNumber
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {
          responses: []
        }
      }
    },
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
  },
  data() {
    return {
      min: -Infinity,
      max: Infinity,
      controls: false
    }
  },
  computed: {
    ...mapGetters(['activeSectionId', 'debugQuestions']),
    providerRules() {
      return {
        requiredNumeric: !this.isOptional,
        min: (this.min !== Infinity && this.max === Infinity) ? { min: this.min } : false,
        max: (this.max !== Infinity && this.min === -Infinity) ? { max: this.max } : false,
        minMax: (this.min !== -Infinity && this.max !== Infinity) ? { min: this.min, max: this.max } : false
      }
    },
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponseTextValue: {
      get() {
        let responses = this.$store.getters.getQuestionResponses(this.question.hspCategoryQuestionId);

        if(responses.length) {
          return responses[0].responseTextValue;
        }

        return undefined;
      },
      set(value) {
        if(value !== undefined) {
          this.$store.dispatch('setQuestionResponse', {
            questionTypeId: this.question.hspQuestionTypeId,
            questionId: this.question.hspCategoryQuestionId,
            responseText: value
          });
        }
      }
    }
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In InputNumber.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    inputLabel(description) {
      return "Number input" + (description && description.length > 0 ? " for " + description : "");
    },
  },
  created() {
    this.question.questionOptions.forEach(option => {
      if(this.hasOwnProperty(option.optionName)) {
        this[option.optionName] = option.optionValue;
      }
    });
  },
  mounted() {
    this.$refs.numProvider.reset();
  }
}
</script>
<style scoped="true">
.input-number-border {
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
  border-top-right-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}
</style>
